import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let uploader = class uploader extends Vue {
    info;
    position;
    previewImgs;
    disabled;
    // fileData: any = null;?
    isValid = false;
    fileList = [];
    previewList = [];
    get title() {
        return this.info?.title ?? '';
    }
    get format() {
        const txt = this.info?.format?.join(',');
        return this.$t('format', { format: txt });
    }
    get size() {
        const txt = this.getSizeText(this.info?.size);
        return this.$t('size', { size: txt });
    }
    get resolution() {
        const txt = this.info?.resolution;
        return txt && this.$t('resolution', { resolution: txt });
    }
    async onpreviewImgs(nv = []) {
        if (nv?.length === 0)
            return;
        let isNeedUpdate = false;
        this.previewList = [];
        for (let i = 0; i < nv.length; i++) {
            const val = nv[i];
            let res = val;
            if (val.indexOf('base64') === -1) {
                // base64无需处理
                res = (await this.imageUrlToBase64(val));
                isNeedUpdate = true;
            }
            this.previewList.push(res);
        }
        isNeedUpdate && this.changeBase64Urls();
    }
    clearPriewImgs() {
        this.fileList = [];
        this.previewList = [];
    }
    handleDelete(idx) {
        if (this.disabled)
            return;
        this.previewList.splice(idx, 1);
        this.changeBase64Urls();
    }
    getSizeText(size) {
        const ceils = {
            KB: [0, 1024 * 1024],
            M: [1024 * 1024, 1024 * 1024 * 1024],
            G: [1024 * 1024 * 1024],
        };
        let ceil = 'KB';
        let num = size;
        Object.keys(ceils).forEach((k) => {
            const arr = ceils[k];
            const isStart = size >= arr[0];
            if (arr.length > 1) {
                const isEnd = size < arr[1];
                if (isStart && isEnd) {
                    num = size / arr[0];
                    ceil = k;
                }
            }
            else {
                if (isStart) {
                    num = size / arr[0];
                    ceil = k;
                }
            }
        });
        return `${num}${ceil}`;
    }
    onExceed(files, fileList) {
        console.log('超出文件上传onExceed', files, 'fileList', fileList);
        this.fileList.splice(fileList.length - files.length, 1, ...files);
        console.log('onExceed result', this.fileList);
        this.onChange(files[0], fileList);
        this.previewList.splice(fileList.length - files.length, 1);
    }
    async onChange(file, fileList) {
        const fileData = file?.raw || file;
        this.isValid = this.validFile(fileData);
        if (!this.isValid) {
            this.$message.error(`${this.format};${this.size}`);
            return;
        }
        this.fileList = fileList;
        const base64 = await this.getBase64Img(fileData);
        this.previewList.push(base64);
        this.changeBase64Urls();
    }
    changeBase64Urls() {
        this.$emit('changeBase64Urls', { base64Urls: this.previewList, sourceData: this.info });
    }
    validFile(file) {
        const isSize = file.size <= (this.info?.size ?? 0);
        const fileName = file.name;
        const nameArr = fileName.split('.');
        const fileType = nameArr[nameArr.length - 1];
        const isFormat = fileType && this.info?.format.some((item) => item.toLowerCase() === fileType.toLowerCase());
        console.log('validFile this.fileData.size', isSize, 'isFormat', isFormat, 'fileType', fileType, 'this.info?.format', this.info?.format);
        return isSize && isFormat;
    }
    async getBase64Img(data) {
        let base64 = '';
        if (data instanceof File) {
            base64 = (await this.fileReader(data));
        }
        else {
            base64 = (await this.imageUrlToBase64(data));
        }
        return base64;
    }
    fileReader(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader(); // 创建 FileReader 对象
            reader.readAsDataURL(file); // 将文件读取为 DataURL (Base64)
            reader.onload = () => {
                const res = reader.result; // 读取完成后，将结果存储到 base64Data
                resolve(res);
            };
            reader.onerror = (error) => {
                reject(error);
            };
        });
    }
    imageUrlToBase64(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous'; // 设置跨域属性（必须）
            img.src = url;
            img.onload = function () {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                const base64 = canvas.toDataURL('image/png'); // 转换为 Base64
                resolve(base64);
            };
            img.onerror = function (error) {
                reject(error);
            };
        });
    }
};
__decorate([
    Prop()
], uploader.prototype, "info", void 0);
__decorate([
    Prop()
], uploader.prototype, "position", void 0);
__decorate([
    Prop({ default: () => [] })
], uploader.prototype, "previewImgs", void 0);
__decorate([
    Prop()
], uploader.prototype, "disabled", void 0);
__decorate([
    Watch('previewImgs', { deep: true, immediate: true })
], uploader.prototype, "onpreviewImgs", null);
uploader = __decorate([
    Component({
        name: 'uploader',
        i18n: {
            messages: {
                zh: {
                    format: 'Supported format: {format}',
                    size: 'Less than {size} size',
                    resolution: 'Resolution: {resolution}',
                },
                en: {
                    format: 'Supported format: {format}',
                    size: 'Less than {size} size',
                    resolution: 'Resolution: {resolution}',
                },
            },
        },
    })
], uploader);
export default uploader;
